import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }

    .card {
        font-family: var(--sgdf-font-sans);
        color: var(--sgdf-color-default);
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: white;
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        margin: 1rem 0px;
        cursor: pointer;
    }

    .card:hover {
        border-color: #0a58ca;
    }

    .card-body {
        flex: 1 1 auto;
        padding: 1rem 1rem;
    }

    .card-title {
        margin: 0.5rem 0;
        font-size: 1.25rem;
    }

    sgdf-icon {
        margin-right: 0.25rem;
    }

    .meeting-list .skeleton {
        background-color: #bbb;
        color: transparent;
    }
`;
//# sourceMappingURL=MeetingTable.styles.js.map